const flagSvgs = require.context('./assets/img/flags', true, /.svg$/);

export default flagSvgs;
